<template>
  <Content
    class="col-span-full"
    :title="$route.name"
    :pagination="{
      count: tableData.count,
      current: +$route.query.p,
      request: 'workflows/inboxes/',
    }"
    @tableData="tableData = $event"
    @loading="loading = $event"
  >
    <el-table
      :empty-text="$t('NO_DATA')"
      :data="tableData.results"
      v-loading="loading"
      :stripe="true"
      style="width: 100%"
    >
      <el-table-column
        sortable
        type="index"
        :align="$i18n.locale == 'fa' ? 'right' : 'left'"
        :label="$t('INDEX')"
        width="60"
      >
        <template slot-scope="scope">
          <div :data-title="$t('INDEX')">
            {{ scope.$index + 1 }}
          </div>
        </template>
      </el-table-column>

      <el-table-column
        :align="$i18n.locale == 'fa' ? 'right' : 'left'"
        label="گردش‌کار"
        min-width="140"
      >
        <template slot-scope="scope">
          <div data-title="گردش‌کار">
            {{ scope.row.workflow.title }}
          </div>
        </template>
      </el-table-column>

      <el-table-column
        :align="$i18n.locale == 'fa' ? 'right' : 'left'"
        label="سازمان"
        min-width="100"
      >
        <template slot-scope="scope">
          <div data-title="سازمان">
            {{ scope.row.organization.title }}
          </div>
        </template>
      </el-table-column>

      <el-table-column
        :align="$i18n.locale == 'fa' ? 'right' : 'left'"
        label="نوع"
        width="130"
      >
        <template slot-scope="scope">
          <div data-title="نوع">
            {{ getTypeLabel(scope.row.content_type) }}
          </div>
        </template>
      </el-table-column>

      <el-table-column
        :align="$i18n.locale == 'fa' ? 'right' : 'left'"
        label="وضعیت"
        width="100"
      >
        <template slot-scope="scope">
          <div data-title="وضعیت">
            {{ scope.row.current_state.fa_title }}
          </div>
        </template>
      </el-table-column>

      <el-table-column
        :align="$i18n.locale == 'fa' ? 'right' : 'left'"
        label="مرحله جاری"
        width="130"
      >
        <template slot-scope="scope">
          <div data-title="مرحله جاری">
            {{ scope.row.current_step.title }}
          </div>
        </template>
      </el-table-column>

      <el-table-column
        :align="$i18n.locale == 'fa' ? 'right' : 'left'"
        label="آخرین عملیات"
        width="120"
      >
        <template slot-scope="scope">
          <div data-title="آخرین عملیات">
            {{ scope.row.performed_action.fa_title }}
          </div>
        </template>
      </el-table-column>

      <el-table-column
        :align="$i18n.locale == 'fa' ? 'right' : 'left'"
        label="تاریخ ایجاد"
        width="140"
      >
        <template slot-scope="scope">
          <div data-title="تاریخ ایجاد">
            {{ formatDate(scope.row.created_at) }}
          </div>
        </template>
      </el-table-column>

      <!-- <el-table-column align="center" label="نهایی‌شده" width="100">
        <template slot-scope="scope">
          <div data-title="نهایی‌شده">
            <el-tag
              :type="scope.row.is_finalized ? 'success' : 'info'"
              size="small"
            >
              {{ scope.row.is_finalized ? 'بله' : 'خیر' }}
            </el-tag>
          </div>
        </template>
      </el-table-column> -->

      <el-table-column
        :align="$i18n.locale == 'fa' ? 'right' : 'left'"
        label="عملیات قابل انجام"
        min-width="250"
      >
        <template slot-scope="scope">
          <div
            data-title="عملیات قابل انجام"
            class="grid workflow-actions grid-cols-3 gap-1"
          >
            <el-button
              v-for="action in scope.row.available_actions"
              :key="action.action_id"
              @click="performAction(scope.row.id, action.action_id)"
              :loading="!!loadingActions[`${scope.row.id}_${action.action_id}`]"
              :disabled="isAnyActionLoading(scope.row.id)"
              :type="getActionType(action.code)"
              size="mini"
            >
              {{ action.fa_title }}
            </el-button>
          </div>
        </template>
      </el-table-column>

      <el-table-column align="center" label="جزئیات" width="110">
        <template slot-scope="scope">
          <div data-title="جزئیات">
            <el-button
              v-if="scope.row.content_type.app_label === 'services'"
              @click="
                showServiceDetails(
                  scope.row.object_id,
                  scope.row.content_type.model
                )
              "
              type="text"
              size="small"
            >
              <i
                class="el-icon-view text-lg cursor-pointer text-purple-700"
              ></i>
            </el-button>
          </div>
        </template>
      </el-table-column>
    </el-table>

    <!-- Service Details Modal -->
    <el-dialog title="جزئیات" :visible.sync="serviceModalVisible" width="800px">
      <div
        v-if="serviceDetails && serviceType === 'companyvehicleservicevisit'"
        class="service-details"
      >
        <!-- Vehicle Info -->
        <div class="grid grid-cols-1 md:grid-cols-5 gap-4 mb-4 pb-4 border-b">
          <div class="detail-item">
            <label>{{ $t('VEHICLE_TITLE') }}:</label>
            <LicensePlate
              :vehicle="serviceDetails.company_vehicle.vehicle"
              :license_plate="serviceDetails.company_vehicle.license_plate"
              :chars="alphaList"
            />
          </div>
          <div class="detail-item">
            <label>{{ $t('DATE') }}:</label>
            <p>{{ formatDate(serviceDetails.date) }}</p>
          </div>
          <div class="detail-item" v-if="serviceDetails.identifier">
            <label>{{ $t('IDENTIFIER') }}:</label>
            <p>{{ serviceDetails.identifier }}</p>
          </div>

          <div class="detail-item">
            <label>{{ $t('DISTANCE_TRAVEL') }}:</label>
            <p
              class="flex"
              v-html="
                $options.filters.numberSeperator1(
                  serviceDetails.odometer / 1000
                )
              "
            ></p>
          </div>
          <div class="detail-item">
            <label>{{ $t('TOTAL_PRICE') }}:</label>
            <p class="text-lg font-semibold text-green-600">
              {{ formatPrice(serviceDetails.total_price) }}
            </p>
          </div>
        </div>

        <!-- Services Items -->
        <div class="my-4 pb-6">
          <el-table
            :data="serviceDetails.items"
            size="small"
            style="width: 100%"
          >
            <el-table-column
              type="index"
              :label="$t('INDEX')"
              width="50"
              align="center"
            />
            <el-table-column
              prop="service.fa_title"
              :label="$t('SERVICE')"
              align="center"
            />
            <el-table-column
              prop="price"
              :label="$t('PRICE')"
              :formatter="(row) => formatPrice(row.price)"
              align="center"
            />
            <el-table-column
              v-if="serviceDetails.items.some((item) => item.day_interval)"
              prop="day_interval"
              :label="$t('DAY_INTERVAL')"
              align="center"
            />
            <el-table-column
              v-if="serviceDetails.items.some((item) => item.meter_interval)"
              prop="meter_interval"
              :label="$t('METER_INTERVAL')"
              align="center"
            />
          </el-table>
        </div>

        <!-- Description -->
        <div v-if="serviceDetails.description" class="mb-4 pb-4 border-b">
          <div class="detail-item">
            <label>{{ $t('DESCRIPTION') }}:</label>
            <p>{{ serviceDetails.description }}</p>
          </div>
        </div>

        <!-- Attachments -->
        <div
          v-if="
            serviceDetails.attachments && serviceDetails.attachments.length > 0
          "
          class="mb-4"
        >
          <div class="detail-item">
            <label>{{ $t('ATTACHMENTS') }}:</label>
            <div class="flex flex-wrap gap-2 mt-2">
              <el-button
                v-for="(attachment, index) in serviceDetails.attachments"
                :key="attachment.id"
                @click="downloadAttachment(attachment.id)"
                :loading="downloadingAttachments[attachment.id]"
                type="primary"
                size="small"
              >
                {{ attachment.title || `${$t('ATTACHMENT')} ${index + 1}` }}
              </el-button>
            </div>
          </div>
        </div>
      </div>
      <div
        v-if="serviceDetails && serviceType === 'companyvehicleservice'"
        class="service-details"
      >
        <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div class="detail-item">
            <label>{{ $t('VEHICLE_TITLE') }}:</label>
            <LicensePlate
              :vehicle="serviceDetails.company_vehicle.vehicle"
              :license_plate="serviceDetails.company_vehicle.license_plate"
              :chars="alphaList"
            />
          </div>
          <div class="detail-item">
            <label>{{ $t('SERVICE') }}:</label>
            <p>{{ serviceDetails.service.fa_title }}</p>
          </div>
        </div>

        <div class="grid grid-cols-1 md:grid-cols-2 gap-6 mt-6">
          <div class="detail-item">
            <label>{{ $t('DATE') }}:</label>
            <p>{{ formatDate(serviceDetails.date) }}</p>
          </div>
          <div class="detail-item">
            <label>{{ $t('PRICE') }}:</label>
            <p>{{ formatPrice(serviceDetails.price) }}</p>
          </div>
        </div>

        <div v-if="serviceDetails.description" class="mt-6">
          <div class="detail-item">
            <label>{{ $t('description') }}:</label>
            <p>{{ serviceDetails.description }}</p>
          </div>
        </div>

        <div
          v-if="
            serviceDetails.attachments && serviceDetails.attachments.length > 0
          "
          class="mt-6"
        >
          <div class="detail-item">
            <label>پیوست‌ها:</label>
            <div class="flex flex-wrap gap-2 mt-2">
              <el-button
                v-for="(attachment, index) in serviceDetails.attachments"
                :key="attachment.id"
                @click="downloadAttachment(attachment.id)"
                :loading="downloadingAttachments[attachment.id]"
                type="primary"
                size="small"
              >
                {{ attachment.title || `پیوست ${index + 1}` }}
              </el-button>
            </div>
          </div>
        </div>
      </div>

      <div v-else-if="serviceLoading" class="text-center py-8">
        <div class="inline-flex items-center">
          <div
            class="
              animate-spin
              rounded-full
              h-6
              w-6
              border-b-2 border-blue-600
              mr-3
            "
          ></div>
          <span class="text-gray-600">{{ $t('LOADING') }}</span>
        </div>
      </div>
    </el-dialog>
  </Content>
</template>

<script>
import { getWorkflowsInboxes, performWorkflowAction } from '@/api/workflows'
import { getAServiceVisit, getAService } from '@/api/services'
import { licenseChars } from '@/api/global'
import { axiosFactory } from '@/configs/axios'
import LicensePlate from '@/components/cars/LicensePlate'

export default {
  data() {
    return {
      tableData: {
        results: [],
      },
      loading: true,
      search: '',
      loadingActions: {},
      serviceModalVisible: false,
      serviceDetails: null,
      serviceType: null,
      serviceLoading: false,
      downloadingAttachments: {},
      alphaList: [
        {
          code: '',
          char: '',
          id: '',
        },
      ],
    }
  },

  methods: {
    getTypeLabel(contentType) {
      if (contentType.app_label === 'services') {
        return 'سرویس دوره‌ای'
      }
      return contentType.app_label
    },
    getActionType(code) {
      if (code === 'approve') return 'success'
      if (code === 'reject') return 'danger'
      return 'default'
    },
    isAnyActionLoading(inboxId) {
      return Object.keys(this.loadingActions).some(
        (key) => key.startsWith(`${inboxId}_`) && this.loadingActions[key]
      )
    },
    async performAction(inboxId, actionId) {
      this.$prompt('یادداشت خود را وارد کنید', 'یادداشت', {
        confirmButtonText: 'تایید',
        cancelButtonText: 'انصراف',
        inputType: 'textarea',
      })
        .then(({ value }) => {
          this.submitAction(inboxId, actionId, value || null)
        })
        .catch(() => {
          // this.submitAction(inboxId, actionId)
        })
    },
    async submitAction(inboxId, actionId, comment = null) {
      const key = `${inboxId}_${actionId}`
      this.$set(this.loadingActions, key, true)
      try {
        const payload = { action_id: actionId }
        if (comment) payload.comment = comment
        await performWorkflowAction.api(inboxId, payload)
        this.$message.success('عملیات با موفقیت انجام شد')
        const res = await getWorkflowsInboxes.api(+this.$route.query.p || 1)
        if (res) this.tableData = res
      } catch (error) {
        this.$message.error('خطا در انجام عملیات')
      } finally {
        this.$set(this.loadingActions, key, false)
      }
    },
    async showServiceDetails(serviceId, model) {
      this.serviceModalVisible = true
      this.serviceLoading = true
      this.serviceDetails = null
      this.serviceType = null
      const api = model.includes('visit') ? getAServiceVisit : getAService

      try {
        const response = await api.api(serviceId)
        if (response) {
          this.serviceDetails = response
          this.serviceType = model
        } else {
          this.serviceModalVisible = false
          this.serviceLoading = false
          this.serviceType = null
        }
      } catch (error) {
        this.$message.error('خطا در بارگذاری جزئیات سرویس')
        this.serviceModalVisible = false
      } finally {
        this.serviceLoading = false
      }
    },
    formatDate(dateString) {
      if (!dateString) return '-'
      const date = new Date(dateString)
      return date.toLocaleDateString('fa-IR')
    },
    formatPrice(price) {
      if (!price) return '0'
      return new Intl.NumberFormat('fa-IR').format(price)
    },
    async downloadAttachment(attachmentId) {
      // Set loading state for this specific attachment
      this.$set(this.downloadingAttachments, attachmentId, true)

      try {
        const response = await axiosFactory({ type: 'blob' }).auth.get(
          `attachments/${attachmentId}/`
        )

        // Get the filename from the response headers or use a default
        const contentDisposition = response.headers['content-disposition']
        let filename = 'attachment'
        if (contentDisposition) {
          const filenameMatch = contentDisposition.match(/filename="(.+)"/)
          if (filenameMatch) {
            filename = filenameMatch[1]
          }
        }

        // Create blob and download
        const blob = new Blob([response.data])
        const url = window.URL.createObjectURL(blob)
        const a = document.createElement('a')
        a.href = url
        a.download = filename
        document.body.appendChild(a)
        a.click()
        window.URL.revokeObjectURL(url)
        document.body.removeChild(a)

        this.$message.success('پیوست با موفقیت دانلود شد')
      } catch (error) {
        console.error('Download error:', error)
        this.$message.error('خطا در دانلود پیوست')
      } finally {
        // Clear loading state for this specific attachment
        this.$set(this.downloadingAttachments, attachmentId, false)
      }
    },
  },
  mounted() {
    getWorkflowsInboxes.api().then((res) => {
      if (res) {
        this.tableData = res
      }
      this.loading = false
    })

    licenseChars.api().then((res) => {
      this.alphaList = res
    })
  },
  components: {
    LicensePlate,
  },
}
</script>

<style scoped>
.service-details {
  padding: 20px 0;
}
.workflow-actions button {
  margin: 0 !important;
  max-width: 70px;
  padding: 7px 0px;
}
.detail-item {
  margin-bottom: 20px;
}

.detail-item label {
  display: block;
  font-weight: bold;
  color: #606266;
  margin-bottom: 8px;
  font-size: 14px;
}

.detail-item p {
  margin: 0;
  color: #303133;
  font-size: 14px;
  line-height: 1.5;
}

.text-center {
  text-align: center;
  padding: 40px 0;
}

.dialog-footer {
  text-align: left;
}
</style>
